import React from 'react';
import moment from 'moment';
import DayPicker from 'react-day-picker';
import 'react-day-picker/lib/style.css';

const DatePicker = ({format, selectedDays, onChange, modifiers, readOnly, ...rest}) => {
  const matchStyle = `
  .DayPicker-Day--highlighted {
    background-color: #2e7d32;
    color: #fff;
  }
  .DayPicker-Day--highlighted:hover {
    background-color: #2e7d32!important;
    color: #fff;
  }
.DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {
  background-color: #299C26;
}

.DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside):hover {
  background-color: #299C26;
}`;
  const getSelectedDays = () => {
    return selectedDays.map((el) => moment(el, format).toDate());
  }
  const handleClick = (date, modifiers = {}) => {
    if (modifiers.disabled) return;
    onChange(moment(date).format(format))
  }
  return (
    <>
      <style>{matchStyle}</style>
      <DayPicker
        {...rest}
        selectedDays={getSelectedDays()}
        onDayClick={handleClick}
        modifiers={modifiers}
        disabledDays={{ before: new Date() }}
        className={!!readOnly ? 'date-picker-disabled' : ''}
      />
    </>
  );
};

export default DatePicker;